import { render, staticRenderFns } from "./Decisoes.vue?vue&type=template&id=54a02d7c"
import script from "./Decisoes.vue?vue&type=script&lang=ts"
export * from "./Decisoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports